// The widget's embed token (K13): from the address the loader built (?token=), kept for this tab so it survives moving
// around inside the widget. The widget's search sends it, and the /embed pages check it before they show anything
// (K13 pt 17); the server checks it both times.
export const readEmbedToken = () => {
  let token = null;
  try { token = new URLSearchParams(window.location.search).get('token'); } catch { /* no address to read */ }
  try {
    if (token) sessionStorage.setItem('beetsol-embed-token', token);
    else token = sessionStorage.getItem('beetsol-embed-token');
  } catch { /* storage unavailable: the address is the only source */ }
  return token;
};
